import { DateTime } from 'luxon';
import { getReportsSellsDates } from '../services/reports/sellsService';
import { toYMD } from '../helpers/dates';

// Genera el listado de días civiles "YYYY-MM-DD" MX entre `since` y `until`,
// inclusive en ambos extremos. Trabajamos en zona MX porque el negocio opera
// en México y el back devuelve los días agregados ya en MX.
const MX_TZ = 'America/Mexico_City';

const civilDaysBetween = (since, until) => {
  const start = DateTime.fromJSDate(since).setZone(MX_TZ).startOf('day');
  const end = DateTime.fromJSDate(until).setZone(MX_TZ).startOf('day');
  const days = [];
  let cursor = start;
  while (cursor <= end) {
    days.push(cursor.toFormat('yyyy-LL-dd'));
    cursor = cursor.plus({ days: 1 });
  }
  return days;
};

// El back devuelve `date` como string "YYYY-MM-DD" (día civil MX). No
// reconvertimos a Date — el contrato del endpoint dejó claro que es un día,
// no un instante. Si por compatibilidad llega con sufijo de tiempo
// ("YYYY-MM-DDT…"), nos quedamos con los 10 primeros caracteres.
const dayOnly = (raw) => (typeof raw === 'string' ? raw.slice(0, 10) : null);

const useSells = () => {
  return {
    getNoSoldDays: ({ since, until }) =>
      getReportsSellsDates({
        since: toYMD(since),
        until: toYMD(until),
      }).then(({ data }) => {
        const soldDays = new Set(data.data.map(({ date }) => dayOnly(date)).filter(Boolean));
        return civilDaysBetween(since, until)
          .filter((day) => !soldDays.has(day))
          .filter((day) => !(day.match(/12-25/g) || day.match(/01-01/g)));
      }),
  };
};

export default useSells;
